<template>
  <div class="container-fluid h-100 p-0">
    <!--    <OnboardingTour
          v-if="showTour"
          v-model="showTour"
          @finish="onTourEnd"
        />-->
    <div class="head">
      <div class="col-12 p-0">
        <div class="container-fluid">
          <div class="row pt-2 app-header-row">
            <div class="col-6 col-sm-4 app-header-brand-col">
              <div class="app-brand-row">
                <div class="mobile-brand-shell d-lg-none">
                  <button type="button" class="mobile-brand-trigger" @click="drawer = true" aria-label="Открыть меню">
                    <el-image class="brand-logo" src="/img/logo_new.png" />
                  </button>
                  <button type="button" class="mobile-menu-toggle" @click="drawer = true" aria-label="Открыть меню">
                    <el-icon><ArrowRight /></el-icon>
                  </button>
                </div>
                <el-image class="brand-logo d-none d-lg-block ms-2" src="/img/logo_new.png" />
                <a
                  href="https://lineon.me"
                  target="_blank"
                  class="ms-3 d-flex align-items-center app-home-link"
                >
                  <el-image class="app-home-icon" src="/img/home.png" alt="Главная" />
                </a>
                <router-link
                  v-if="user?.subscription && (user.subscription.status === 'demo' || user.subscription.days_left <= 7)"
                  to="/billing"
                  class="subscription-badge subscription-badge--header ms-2 d-flex align-items-center">
                  {{ user.subscription.status === 'demo'
                    ? `Демо: ${user.subscription.days_left} дн.`
                    : `Осталось: ${user.subscription.days_left} дн.` }}
                </router-link>
              </div>
            </div>
            <div class="d-none d-lg-flex col-lg-5 align-items-center justify-content-end app-header-tools-col" v-if="isLogin">
              <div id="app-header-tools" class="header-page-tools"></div>
            </div>
            <div class="col-3 text-end pe-5 d-none" v-if="isLogin">
              <el-dropdown>
                <span class="el-dropdown-link">
                  {{ userName }}
                  <el-icon class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item @click="Logout">
                      <font-awesome-icon class="out-icon" :icon="['fas', 'right-from-bracket']" />
                      Выход
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="col-6 col-sm-3 col-lg-3 text-end pe-sm-4 pe-lg-5 app-header-user-col" v-if="isLogin">
              <div class="user-info">
                <a
                  href="https://lineon.me"
                  target="_blank"
                  class="app-home-link app-home-link--mobile"
                  aria-label="Главная"
                >
                  <el-image class="app-home-icon" src="/img/home.png" alt="Главная" />
                </a>
                <router-link
                  v-if="user?.subscription && (user.subscription.status === 'demo' || user.subscription.days_left <= 7)"
                  to="/billing"
                  class="subscription-badge subscription-badge--mobile"
                >
                  {{ user.subscription.status === 'demo'
                    ? `Демо: ${user.subscription.days_left} дн.`
                    : `Осталось: ${user.subscription.days_left} дн.` }}
                </router-link>
                <div class="avatar">
                  <div class="avatar-container">
                    <el-upload
                      class="avatar-uploader"
                      action="#"
                      :show-file-list="false"
                      :before-upload="file => beforeAvatarUpload(file)"
                      :http-request="params => handleAvatarUpload(params)">
                      <div class="avatar-hover-container">
                        <el-avatar :src="avaString" :size="40">
                          <template v-if="!avaString">{{ getInitials(userName) }}</template>
                        </el-avatar>
                        <transition name="fade">
                          <div class="avatar-hover-mask">
                            <el-icon class="avatar-hover-icon">
                              <Upload />
                            </el-icon>
                          </div>
                        </transition>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="user-block">
                  <div class="name">{{ userName }}</div>
                  <div class="email">{{ userMail }}</div>
                </div>
                <div class="exit-block">
                  <el-button link @click="Logout">
                    <font-awesome-icon class="out-icon" :icon="['fas', 'right-from-bracket']" />
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-main" :class="{ 'content-main-calendar': $route.path === '/' }" v-if="isLogin">
      <div class="nav-menu d-none d-lg-block">
          <div class="sidebar">
          <div class="menu-top">
            <el-menu
              :default-active="default_active"
              router
              popper-effect="dark"
              active-text-color="var(--ui-color-brand)"
              background-color="var(--ui-color-sidebar-bg)"
              text-color="var(--ui-color-border-soft)"
              class="navigations"
              :key="menuKey">
              <el-menu-item index="/">
                <div class="nav-link">
                  <img src="/img/calendar.svg" alt="Запись" class="menu-icon" />
                  <span>Запись</span>
                </div>
              </el-menu-item>
              <el-menu-item index="/schedules" v-if="accessibleSections['Расписание']">
                <div class="nav-link">
                  <img src="/img/shifts.svg" alt="Смены" class="menu-icon" />
                  <span>Смены</span>
                </div>
              </el-menu-item>
              <el-menu-item index="/contacts" v-if="accessibleSections['Контакты']">
                <div class="nav-link">
                  <img src="/img/clients.svg" alt="Клиенты" class="menu-icon" />
                  <span>Клиенты</span>
                </div>
              </el-menu-item>
              <el-menu-item index="/certificates" v-if="accessibleSections['Абонементы']">
                <div class="nav-link">
                  <img src="/img/cert.svg" alt="Сертификаты" class="menu-icon" />
                  <span>Сертификаты</span>
                </div>
              </el-menu-item>
              <el-menu-item index="/client-payments" v-if="accessibleSections['Транзакции']">
                <div class="nav-link">
                  <img src="/img/money.svg" alt="Покупки" class="menu-icon" />
                  <span>Покупки</span>
                </div>
              </el-menu-item>
              <el-menu-item index="/services" v-if="accessibleSections['Услуги']">
                <div class="nav-link">
                  <img src="/img/services.svg" alt="Услуги" class="menu-icon" />
                  <span>Услуги</span>
                </div>
              </el-menu-item>
              <el-menu-item index="/dialogs" v-if="user?.is_admin || user?.permissions === '*'">
                <div class="nav-link">
                  <el-badge :value="unreadMessage" v-if="unreadMessage > 0">
                    <img src="/img/chat.svg" alt="Чаты" class="menu-icon" />
                  </el-badge>
                  <img v-else src="/img/chat.svg" alt="Чаты" class="menu-icon" />
                  <span>Чаты</span>
                </div>
              </el-menu-item>
            </el-menu>
          </div>
          <div class="menu-bottom">

            <el-menu
              :default-active="default_active"
              router
              :collapse="true"
              :show-timeout="100"
              popper-effect="dark"
              active-text-color="var(--ui-color-brand)"
              background-color="var(--ui-color-sidebar-bg)"
              text-color="var(--ui-color-border-soft)"
              class="navigations">
              <el-sub-menu
                index="settings-desktop"
                class="setting"
                v-if="hasAnySettingsAccess"
                popper-class="settings-popper"
                :popper-offset="10">
                <template #title>
                  <img src="/img/settings.svg" alt="Настройки" class="menu-icon" />
                  <span>Настройки</span>
                </template>
                <el-menu-item-group title="Настройки">
                  <el-menu-item v-if="accessibleSettings.branches" index="/branches">Филиалы</el-menu-item>
                  <el-menu-item v-if="accessibleSettings.employees" index="/employees">Сотрудники</el-menu-item>
                  <el-menu-item v-if="accessibleSettings.customFields" index="/custom-fields">Пользовательские поля</el-menu-item>
                  <el-menu-item v-if="accessibleSettings.messengers" index="/messengers">Мессенджеры</el-menu-item>
                  <el-menu-item v-if="accessibleSettings.settings" index="/settings">Общие</el-menu-item>
                  <el-menu-item v-if="accessibleSettings.billing" index="/billing">Счёт и оплата</el-menu-item>
                </el-menu-item-group>
              </el-sub-menu>
            </el-menu>
          </div>
        </div>
      </div>
      <div class="router-content">
        <router-view />
      </div>
    </div>
    <div class="admin-block" style="height: 100%;" v-else-if="!isLogin && admin">
      <router-view />
    </div>
    <div class="content-main" v-else>
      <router-view
        v-if="$route.path === '/register' || $route.path === '/forgot-password' || $route.path === '/reset-password'" />
      <LoginBlock v-else />
    </div>
  <!-- SUBSCRIPTION EXPIRED OVERLAY -->
  <div
    v-if="isSubscriptionExpired && !isBillingPage"
    class="subscription-overlay">
    <div class="subscription-modal">
      <h2>Подписка недействительна</h2>
      <p>Срок действия вашей подписки истёк.</p>
      <el-button type="primary" size="large" @click="$router.push('/billing')">
        Перейти к оплате
      </el-button>
    </div>
  </div>
  </div>
  <el-drawer v-model="drawer" direction="ltr" title="Навигация" :with-header="false">
    <div class="h-100 position-relative">
      <div class="drawer-mobile-header d-lg-none">
        <el-image class="brand-logo drawer-mobile-header__logo" src="/img/logo_new.png" />
        <button type="button" class="drawer-mobile-close" @click="drawer = false" aria-label="Закрыть меню">
          <el-icon><ArrowLeft /></el-icon>
        </button>
      </div>
      <el-menu
        :default-active="default_active"
        router
        :show-timeout="100"
        popper-effect="dark"
        active-text-color="var(--cal-accent)"
        background-color="var(--cal-bg-panel)"
        text-color="var(--cal-text-regular)"
        class="navigations"
        :key="menuKey"
        :collapse="false">
        <el-menu-item index="/">
          <div class="nav-link">
            <img src="/img/calendar.svg" alt="Запись" class="menu-icon" />
            <span>Запись</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/schedules" v-if="accessibleSections['Расписание']">
          <div class="nav-link">
            <img src="/img/shifts.svg" alt="Смены" class="menu-icon" />
            <span>Смены</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/contacts" v-if="accessibleSections['Контакты']">
          <div class="nav-link">
            <img src="/img/clients.svg" alt="Клиенты" class="menu-icon" />
            <span>Клиенты</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/certificates" v-if="accessibleSections['Абонементы']">
          <div class="nav-link">
            <img src="/img/cert.svg" alt="Сертификаты" class="menu-icon" />
            <span>Сертификаты</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/client-payments" v-if="accessibleSections['Транзакции']">
          <div class="nav-link">
            <img src="/img/money.svg" alt="Покупки" class="menu-icon" />
            <span>Покупки</span>
          </div>
        </el-menu-item>
        <el-menu-item index="/services" v-if="accessibleSections['Услуги']">
          <div class="nav-link">
            <img src="/img/services.svg" alt="Услуги" class="menu-icon" />
            <span>Услуги</span>
          </div>
        </el-menu-item>

        <el-sub-menu index="settings-mobile" class="setting" v-if="hasAnySettingsAccess">
          <template #title>
            <img src="/img/settings.svg" alt="Настройки" class="menu-icon" />
            <span>Настройки</span>
          </template>
          <el-menu-item-group title="Настройки">
            <el-menu-item v-if="accessibleSettings.branches" index="/branches">Филиалы</el-menu-item>
            <el-menu-item v-if="accessibleSettings.employees" index="/employees">Сотрудники</el-menu-item>
            <el-menu-item v-if="accessibleSettings.customFields" index="/custom-fields">Пользовательские поля</el-menu-item>
            <el-menu-item v-if="accessibleSettings.messengers" index="/messengers">Мессенджеры</el-menu-item>
            <el-menu-item v-if="accessibleSettings.settings" index="/settings">Настройки</el-menu-item>
            <el-menu-item v-if="accessibleSettings.billing" index="/billing">Счёт и оплата</el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>
      </el-menu>
    </div>
  </el-drawer>
</template>
<script>
import store from '@/components/store/store'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ArrowDown, ArrowLeft, ArrowRight, Upload } from '@element-plus/icons-vue'
import LoginBlock from '@/components/LoginBlock.vue'
import { ElMessageBox } from 'element-plus'
import { mapActions, mapGetters, mapState } from 'vuex'
import { canAccessSection, permissionGroups } from '@/components/util/accessHelper'
import { getCookieValue, setCookieValue } from '@/components/util/cookies'

export default {
  name: 'App',
  data() {
    return {
      default_active: null,
      drawer: false,
      admin: false,
      client: '',
      menuKey: 0,
      showTour: false
    }
  },
  async created() {
    const urlParams = new URLSearchParams(window.location.search)
    const ref = urlParams.get('ref')

    console.log(ref);

    if (ref) {
      setCookieValue('referral_code', ref, '30d')
    }

    if (getCookieValue('token')) {
      store.dispatch('auth/setIsLogin', true)
      store.dispatch('socket/connect')
    }

    const path = window.location.pathname
    this.setActiveFromPath(path)

    if (path === '/adminAmogen') {
      this.admin = true
    }
  },
  computed: {
    accessibleSections() {
      const access = {}
      for (const sectionName of Object.keys(permissionGroups)) {
        access[sectionName] = canAccessSection(sectionName)
      }
      return access
    },
    accessibleSettings() {
      return {
        branches: canAccessSection('Локации'),
        employees: canAccessSection('Сотрудники'),
        customFields: canAccessSection('Сотрудники') || canAccessSection('Локации'),
        messengers: this.user?.is_admin || this.user?.permissions === '*',
        settings: canAccessSection('Локации'),
        billing: this.user?.is_admin || this.user?.permissions === '*'
      }
    },
    hasAnySettingsAccess() {
      return Object.values(this.accessibleSettings).some(v => v)
    },
    ...mapGetters('auth', ['isLogin', 'userName', 'avaString', 'userMail', 'userID']),
    ...mapState('auth', ['user']),
    ...mapState('messengers', ['unreadMessage']),
    isSubscriptionExpired() {
      const sub = this.user?.subscription;
      if (!sub) return false;
      return Number(sub.days_left) <= 0;
    },
    isBillingPage() {
      return this.$route.path.startsWith('/billing')
    }
  },
  components: { Upload, ArrowDown, ArrowLeft, ArrowRight, LoginBlock, FontAwesomeIcon },
  methods: {
    ...mapActions(['uploadAvatar']),
    setActiveFromPath(path) {
      if (!path) {
        this.default_active = '/'
        return
      }

      if (path.startsWith('/billing')) {
        this.default_active = '/billing'
        return
      }

      this.default_active = path
    },
    async handleAvatarUpload(file) {
      const employeeId = this.userID
      await this.$store.dispatch('uploadAvatar', {
        file,
        data: { employeeId }
      })
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) this.$message.error('Можно загружать только изображения!')
      if (!isLt10M) this.$message.error('Размер файла не должен превышать 10 МБ!')
      return isImage && isLt10M
    },
    getInitials(fullName) {
      if (!fullName) return ''
      const parts = fullName.trim().split(' ')
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase()
    },
    Logout() {
      ElMessageBox.confirm(
        'Вы уверены что хотите выйти?',
        'Внимание',
        {
          confirmButtonText: 'Выход',
          cancelButtonText: 'Отмена',
          type: 'warning',
          customClass: 'logout-confirm'
        }
      )
        .then(() => {
          store.dispatch('auth/revokeUser')
        })
        .catch(() => {
          console.debug('cancel')
        })
    },
    async onTourEnd() {
      await store.dispatch('auth/finishOnboarding')
      this.showTour = false
    }
  },
  watch: {
    isLogin(newVal) {
      if (newVal) {
        store.dispatch('socket/connect')
        this.setActiveFromPath(this.$route.path)
        this.menuKey++     // форсируем перерисовку меню, чтобы отобразились доступные пункты
      }
    },
    $route(to) {
      this.drawer = false
      this.setActiveFromPath(to.path)
      this.menuKey++
    },
    user(newVal) {
      if (newVal?.is_new_user) {
        this.showTour = true
      }
    }
  }
}
</script>
<style>
.settings-popper {
  left: 84px !important;
  border: none !important;
  background: var(--cal-bg-panel) !important;
  color: var(--cal-text-regular) !important;
  border-radius: 16px !important;
  box-shadow: 0 18px 32px rgba(2, 10, 28, 0.34) !important;
  overflow: hidden;
}
.settings-popper .el-menu-item {
  align-items: normal;
  justify-content: normal !important;
  flex-direction: column !important;
  padding: 0 var(--el-menu-base-level-padding) !important;
}
.user-info {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;

  .avatar {
    display: flex;
    width: 40px;
    height: 40px;
    background-color: var(--cal-accent-strong);
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    color: var(--cal-text-inverse);
    flex: 0 0 40px;
  }

  .user-block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    min-width: 0;

    .name {
      max-width: 210px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--cal-text-inverse);
      font-size: 18px;
      line-height: 1;
      font-weight: 700;
      text-decoration: underline;
      text-decoration-thickness: 1px;
      text-underline-offset: 2px;
    }

    .email {
      color: var(--cal-text-muted);
      font-size: 11px;
      line-height: 1;
      max-width: 210px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .exit-block {
    margin-left: 2px;
  }
}

.out-icon {
  font-size: 18px;
  color: var(--cal-accent);
}

#app {
  font-family: var(--ui-font-family-base);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--cal-text-regular);
  background: #000714;
  min-height: 100vh;
}

#app .common-layout {
  padding: 0 40px;
}

#app .login-name {
  display: flex;
  color: var(--cal-accent);
  cursor: pointer;
  justify-content: flex-end;
  align-items: center;
}

#app .login-name i {
  margin-left: 5px;
}
</style>
<style>
.el-drawer {
  width: min(280px, calc(100vw - 28px)) !important;

  .el-drawer__body {
    padding: 0 !important;
  }

  .el-sub-menu.setting {
    bottom: 0;
  }
}

@media (min-width: 992px) {
  .el-drawer {
    width: 64px !important;
  }
}

.el-drawer .el-menu-item,
.el-drawer .el-sub-menu__title {
  justify-content: flex-start !important;
  height: 56px;
  padding: 0 18px !important;
}

.el-drawer .nav-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 12px;
  width: 100%;
  text-decoration: none;
  text-align: left;
}

.el-drawer .nav-link span,
.el-drawer .el-sub-menu__title span {
  margin-top: 0 !important;
  font-size: 14px !important;
  line-height: 1.2;
}

.el-drawer .menu-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.el-drawer .el-sub-menu.setting .el-sub-menu__title {
  justify-content: flex-start;
  flex-direction: row;
  gap: 12px;
  margin-bottom: 0;
  padding: 0 18px !important;
}

.el-drawer .el-menu-item-group__title {
  padding-left: 18px !important;
  color: var(--cal-text-muted) !important;
}

.user-info .el-upload {
  margin-top: 0 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.el-avatar {
  background-color: var(--cal-accent-strong) !important;
}

.el-form-item.is-success .el-input__wrapper {
  color: var(--ui-color-success); /* ярко-зеленый */
  box-shadow: 0 0 0 1px var(--el-color-success) inset
}

.el-form-item.is-success .el-input__validateIcon {
  color: var(--el-color-success);
}

.out-icon {
  margin-right: 4px;
}

.sidebar .el-sub-menu.setting .el-sub-menu__title {
  justify-content: center;
  flex-direction: column;
  min-height: 72px;
  margin: 0 0 6px;
  padding: 8px 6px !important;
  border-radius: 0;
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
  transition: background 0.2s, box-shadow 0.2s;
}
</style>

<style scoped>
/* Исправляем позиционирование бейджа */
.menu-top .el-menu-item .el-badge {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

/* Чтобы бейдж не выталкивал иконку вниз */
.menu-top .el-menu-item .el-badge__content.is-fixed {
  transform: translate(6px, -6px) !important;
}

.head {
  display: flex;
  background: #000714;
  min-height: 68px;
  padding: 8px 0 6px;
  border-bottom: 1px solid rgba(15, 32, 66, 0.42);
}

.app-header-row {
  align-items: center;
}

.app-brand-row {
  display: flex;
  align-items: center;
  gap: 14px;
}

.mobile-brand-shell,
.mobile-menu-toggle,
.app-home-link--mobile,
.drawer-mobile-header,
.drawer-mobile-close {
  display: none;
}

.brand-logo {
  width: 122px;
  display: block;
}

.header-page-tools {
  width: min(356px, 100%);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

@media (min-width: 992px) {
  .app-header-row {
    flex-wrap: nowrap;
  }

  .app-header-brand-col,
  .app-header-tools-col,
  .app-header-user-col {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }

  .app-header-tools-col {
    margin-left: auto;
    padding-left: 0;
    padding-right: 0;
  }

  .app-header-user-col {
    margin-left: 12px;
    padding-left: 0;
  }

  .header-page-tools {
    width: auto;
  }

  .header-page-tools:not(:empty) {
    width: 356px;
  }
}

.mobile-brand-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.subscription-badge {
  background: var(--cal-warning);
  color: var(--cal-text-inverse);
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
}

.subscription-badge--mobile {
  display: none;
}

.app-home-link {
  text-decoration: none;
}

.app-home-icon {
  width: 24px;
  display: block;
}

.content-main {
  position: relative;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: calc(100dvh - 68px);
  display: flex;
}

.content-main-calendar {
  overflow: hidden;
}

.nav-menu {
  width: 84px;
  height: 100%;
}

.navigations {
  height: 100%;
  border: none;
  width: 100%;
}

.router-content {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  height: calc(100dvh - 68px);
  margin-top: 0;
  overflow: hidden;
}

.navbar {
  border-bottom: none;
}

.avatar-hover-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 50%;
  overflow: hidden;
  line-height: 0;
}

.avatar-hover-container :deep(.el-avatar) {
  width: 100% !important;
  height: 100% !important;
}

.avatar-container,
.avatar-uploader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.avatar-container {
  width: 40px;
  height: 40px;
}

.avatar-hover-mask {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: var(--ui-color-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  border-radius: 50%;
  z-index: 1;
}

.avatar-hover-container:hover .avatar-hover-mask {
  opacity: 1;
  pointer-events: auto;
}

.avatar-hover-icon {
  color: var(--ui-color-white);
  font-size: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  transform: translateY(-1px);
}

.avatar-hover-icon :deep(svg) {
  display: block;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.fade-enter-to, .fade-leave-from {
  opacity: 1;
}

.sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(180deg, #0c2454 0%, #06122c 100%);
  width: 84px;
}

.menu-top {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 0;
}

.menu-bottom {
  flex: 0 0 auto;
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid rgba(78, 104, 150, 0.26);
}

.menu-top::-webkit-scrollbar {
  width: 6px;
}

.menu-top::-webkit-scrollbar-track {
  background: var(--cal-bg-panel);
}

.menu-top::-webkit-scrollbar-thumb {
  background-color: var(--cal-border-soft);
  border-radius: 4px;
}

.menu-top::-webkit-scrollbar-thumb:hover {
  background-color: var(--cal-border);
}

</style>
<style scoped>
.menu-top .el-menu-item .nav-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  height: 100%;
  width: 100%;
  padding-top: 8px;
  font-size: 12px;
  color: #8cb1de;
  text-decoration: none;
  text-align: center;
}

.menu-top .el-menu-item .nav-link span {
  white-space: normal;
  line-height: 1.1;
  font-size: 10px;
  font-weight: 600;
  color: #ffffff;
}

.menu-top .el-menu-item.is-active .nav-link,
.settings-popper .el-menu-item.is-active .nav-link,
.settings-popper .el-menu-item.is-active .nav-link span,
.menu-top .el-menu-item.is-active .nav-link span {
  color: var(--ui-color-brand) !important;
}

.menu-top .el-menu-item:hover .nav-link,
.settings-popper .el-menu-item:hover .nav-link,
.settings-popper .el-menu-item:hover .nav-link span,
.menu-top .el-menu-item:hover .nav-link span {
  color: var(--ui-color-brand);
}

.menu-top .el-menu-item {
  justify-content: center;
  height: 72px;
  transition: all 0.2s;
  padding: 0 !important;
  border-left: none;
  border-top: 0 !important;
  border-bottom: 0 !important;
  outline: 0 !important;
}

.menu-top :deep(.el-menu),
.menu-top :deep(.el-menu-item),
.menu-top :deep(.el-menu-item::before),
.menu-top :deep(.el-menu-item::after),
.menu-top :deep(.el-menu--vertical),
.menu-top :deep(.el-menu--popup) {
  border: 0 !important;
  box-shadow: none !important;
}

.sidebar .el-sub-menu.setting .fa-gear {
  font-size: 22px !important;
  color: var(--cal-text-regular);
  transition: color 0.2s;
}

.sidebar .el-sub-menu.setting span {
  margin-top: 6px;
  font-size: 10px;
  line-height: 1.1;
  font-weight: 500;
  visibility: visible !important;
  overflow: visible !important;
  width: auto !important;
}

.sidebar .el-sub-menu.setting:hover .fa-gear,
.sidebar .el-sub-menu.setting:hover span,
.sidebar .el-sub-menu.setting.is-active .fa-gear {
  color: var(--ui-color-brand) !important;
}

.sidebar .el-sub-menu.setting:hover > .el-sub-menu__title,
.sidebar .el-sub-menu.setting.is-opened > .el-sub-menu__title,
.sidebar .el-sub-menu.setting.is-active > .el-sub-menu__title {
  background: rgba(16, 53, 117, 0.52) !important;
  box-shadow: inset 0 0 0 1px rgba(72, 201, 255, 0.12) !important;
}

.menu-bottom {
  padding-top: 6px;
  padding-bottom: 6px;
}
.menu-icon {
  width: 30px;
  height: 30px;
  filter: brightness(0) invert(1);
  transition: filter 0.2s;
}

.el-menu-item:hover .menu-icon,
.el-menu-item.is-active .menu-icon,
.el-sub-menu.setting.is-active .menu-icon,
.el-sub-menu.setting:hover .menu-icon {
  filter: invert(53%) sepia(90%) saturate(458%) hue-rotate(162deg) brightness(98%) contrast(98%);
}

.menu-top .el-menu-item.is-active {
  background: rgba(16, 53, 117, 0.52) !important;
  box-shadow: none !important;
}


.subscription-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--ui-color-overlay);
  backdrop-filter: blur(2px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subscription-modal {
  background: var(--cal-bg-panel-alt);
  color: var(--cal-text-inverse);
  padding: 35px 50px;
  border-radius: 12px;
  box-shadow: var(--ui-shadow-modal);
  text-align: center;
  max-width: 450px;
}

@media (max-width: 991px) {
  .head {
    min-height: 64px;
    padding: 8px 0 6px;
  }

  .app-brand-row {
    gap: 10px;
  }

  .mobile-brand-shell {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }

  .brand-logo {
    width: 102px;
  }

  .mobile-menu-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: none;
    border-radius: 50%;
    background: linear-gradient(180deg, #123264 0%, #0b2145 100%);
    box-shadow: 0 0 0 1px rgba(45, 96, 176, 0.56) inset;
    color: #00c3fe;
    flex-shrink: 0;
  }

  .mobile-menu-toggle .el-icon {
    font-size: 16px;
  }

  .content-main,
  .router-content {
    height: calc(100dvh - 64px);
  }

  .nav-menu {
    display: none !important;
    width: 0;
  }

  .app-home-link {
    display: none !important;
  }

  .subscription-badge--header {
    display: none !important;
  }

  .subscription-badge--mobile {
    display: inline-flex;
    align-items: center;
    margin-right: 0;
    font-size: 10px;
    padding: 3px 6px;
  }

  .app-home-link.app-home-link--mobile {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
  }

  .app-home-link--mobile .app-home-icon {
    width: 25px;
  }

  .user-info {
    gap: 6px;
    justify-content: flex-end;
  }

  .user-info .avatar {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }

  .avatar-container,
  .avatar-hover-container,
  .avatar-hover-mask {
    width: 36px;
    height: 36px;
  }

  .avatar-hover-container :deep(.el-avatar) {
    width: 36px !important;
    height: 36px !important;
  }

  .drawer-mobile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px 10px;
    border-bottom: 1px solid rgba(45, 96, 176, 0.28);
    background: linear-gradient(180deg, rgba(13, 35, 85, 0.94) 0%, rgba(8, 21, 52, 0.98) 100%);
  }

  .drawer-mobile-header__logo {
    width: 94px;
  }

  .drawer-mobile-close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 50%;
    background: linear-gradient(180deg, #123264 0%, #0b2145 100%);
    box-shadow: 0 0 0 1px rgba(45, 96, 176, 0.56) inset;
    color: #00c3fe;
    flex-shrink: 0;
  }

  .drawer-mobile-close .el-icon {
    font-size: 18px;
  }

  .user-info .user-block,
  .user-info .exit-block {
    display: none;
  }
}

@media (max-width: 575px) {
  .head {
    min-height: 58px;
    padding: 7px 0 5px;
  }

  .brand-logo {
    width: 84px;
  }

  .mobile-brand-shell {
    gap: 8px;
  }

  .subscription-badge--mobile {
    font-size: 9px;
    padding: 3px 5px;
  }

  .user-info {
    gap: 5px;
  }

  .content-main,
  .router-content {
    height: calc(100dvh - 58px);
  }

  .subscription-modal {
    margin: 0 12px;
    padding: 24px 18px;
  }
}

</style>
